<script>
  import { layoutMethods  } from "@/state/helpers";
  import { rouletteMethods,rouletteComputed  } from "@/state/helpers";
  export default {
    page: {
      title: "Roulette Main"
    },
    data() {
      return {
        title: "Roulette Main",
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90 ,100],
        fields: [
          {
            key: "name",
            sortable: true,
          },
          {
            key: "type",
            sortable: true,
          },
          {
            key: "item_counts",
            sortable: true,
          },
          {
            key: "status",
            sortable: true,
          },
        ],
        pagination: {
            "page": 1,
            "rows" : 10,
            "sort": "rm.id",
            "orderDesc": true,
            "search": "",
            "search_field":  "",
            "filter":  "",
            "filter_by": ""
        },
        submitted: false,
      };
    },
    components: { 
    },
    computed: {
      ...rouletteComputed
    },
    methods: {
      ...layoutMethods,
      ...rouletteMethods,
      populateRouletteMain(){
        this.onPageUpdate();
      },
     
      onPageUpdate() {
       
          this.listRouletteMain(this.pagination)
      },
      refresh(){
        this.populateRouletteMain();
        
      },
      tableSorting(action){
        var column = "";
        switch(action.sortBy){
            case 'name' :
                column = 'rm.title';
                break;
            case 'type' :
                column = 'rm.type';
                break;
            case 'item_counts' :
                column = 'itemCounts';
                break;
            case 'status' :
                column = 'rm.enabled';
                break;
        }
        
        this.pagination.sort = column;
        this.pagination.orderDesc = action.sortDesc;
  
        this.populateRouletteMain(this.pagination)     
        
      }
    },
    mounted(){
      this.populateRouletteMain({ rows: 999999, sort: "id", orderDesc: true});
      this.changeTitle({title: 'Roulette Main'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Roulette Main'}
        ]
      });
    }
  }
    
</script>

<template>
  <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4 mb-4">
                <div class="my-2">
                  <h5 class="card-title text-dark">
                    <span class="fw-normal ms-lg-2">{{mainTotalRows}}</span> Record(s)
                  </h5>
                </div>
              </div>

              <div class="col-md-8 col-sm-8">
                  <div class="d-flex justify-content-lg-end mb-lg-3">
                      <div class="export-btn float-end">
                          <router-link :to="{ name: 'Roulette Main Add'}" class="tc-white">
                            <button class="btn btn-primary me-2">
                                <i class="uil uil-plus me-1"></i> Add Roulette
                            </button>
                          </router-link>
                      </div> <!-- End of Add Roulette button -->

                      <a class="btn btn-secondary"
                        @click="refresh"
                          ><feather
                          type="refresh-ccw"
                          size="16"
                          class="icon nav-icon"
                          ></feather
                          >&nbsp;&nbsp; Refresh</a
                      >
                  </div>
              </div>
              <div class="row">
                </div>
                  <div class="table-responsive">
                    <div class="table align-middle table-nowrap">
                      <b-table
                        :items="rouletteMain"
                        :fields="fields"
                        responsive="sm"
                        :current-page="currentPage"
                        class="table-check"
                        @sort-changed="tableSorting"
                      >
        
                        <template #cell(name)="data">
                          <span class="text-body m-0"><router-link :to="{ name: 'Roulette Main Edit', params: { id: data.item.rouletteId }}" class="customer-name">{{ data.item.rouletteTitle }}</router-link></span>
                        </template>
                        <template #cell(type)="data">
                          <p >{{ data.item.rouletteType }}</p>
                        </template>
                        <template #cell(item_counts)="data">
                          <p >{{ data.item.itemCounts }}</p>
                        </template>
                        <template #cell(status)="data">
                          <span :class="`${data.item.rouletteEnabled == 1 ?  'text-success': 'text-danger'}`">
                            {{ data.item.rouletteEnabled == 1 ? 'Actived' : 'Deactived' }}
                          </span>
                        </template>
                         <!-- <template #cell(backgroud)="data">
                          <div class="avatar-sm"><div class="avatar-title rounded-circle" :style="{ backgroundColor: data.item.itemBackgroundColor  }"> </div></div>
                        </template> -->
                            
                      </b-table>
                    </div>
                  </div>
                  <div class="row g-0 text-center" v-if="mainTotalRows == 0">
                    <span>No data to display.</span>
                  </div>
                  <div class="row g-0 text-center text-sm-start" v-if="mainTotalRows != 0 && mainTotalRows > 10">
                  <!-- end col -->
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="col">
                        <div class="form-group row pull-left">
                          <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                          <div class="col-sm-6">
                            <b-form-group label-for="display-record">
                              <b-form-select class="form-select shadow-none w-fit"
                                id="display-record"
                                v-model="pagination.rows"
                                :options="pageOptions"
                                @change="onPageUpdate()"
                              ></b-form-select>
                            </b-form-group>
                          </div>
                        </div>
                        <div
                          class="
                            dataTables_paginate
                            paging_simple_numbers
                            float-end
                          "
                        >
                          <!-- pagination -->
                          <div class="row g-0 text-center" v-if="mainTotalRows == 0">
                            <span>No data to display.</span>
                          </div>
                          <b-pagination
                            v-if="mainTotalRows != 0 && mainTotalRows > pagination.rows"
                            class="pagination-rounded"
                            v-model="pagination.page"
                            :total-rows="mainTotalRows"
                            @input="onPageUpdate()"
                            :per-page="pagination.rows"
                          ></b-pagination>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
</template>


<style scoped>
  .btn {
    cursor: pointer;
  }
</style>